import { _exporterBase } from "../_exporterBase";
import { ZOOM_ATTENDANCE_CONSTANTS } from "ui/pages/ZoomAttendance/ZoomAttendanceOfListing/constants/ZoomAttendance.constants";

import { formatMinutesText } from "ui/pages/ZoomAttendance/ZoomAttendanceOfListing/utils/ZoomAttendance.utils";

const formatExportPhone = (record) => {
  const code = record.customer_country_code || record.country_code || "+91";
  const rawPhone = (
    record.customer_phone ||
    record.customer_phone_numer ||
    record.phone ||
    ""
  )
    .toString()
    .replace(/\s/g, "")
    .replace(/-/g, "");

  if (!rawPhone) return "--";

  const dialCode = code.replace("+", "");
  let nationalPhone = rawPhone;
  if (dialCode && rawPhone.startsWith(dialCode)) {
    nationalPhone = rawPhone.slice(dialCode.length);
  }

  if (nationalPhone.length === 10) {
    return `${code} ${nationalPhone.slice(0, 5)}-${nationalPhone.slice(5)}`;
  }
  return `${code} ${nationalPhone}`;
};

const exporter_config = [
  {
    field: ZOOM_ATTENDANCE_CONSTANTS.FIELDS.CUSTOMER_NAME,
    headerName: ZOOM_ATTENDANCE_CONSTANTS.LABELS.CUSTOMER_NAME,
    valueFormatter: (record) =>
      record.customer_name || record.name || record.user_name || "--",
  },
  {
    field: ZOOM_ATTENDANCE_CONSTANTS.FIELDS.CUSTOMER_EMAIL,
    headerName: ZOOM_ATTENDANCE_CONSTANTS.LABELS.EMAIL,
    valueFormatter: (record) =>
      record.customer_email || record.user_email || record.email || "--",
  },
  {
    field: ZOOM_ATTENDANCE_CONSTANTS.FIELDS.CUSTOMER_PHONE,
    headerName: ZOOM_ATTENDANCE_CONSTANTS.LABELS.PHONE,
    valueFormatter: formatExportPhone,
  },
  {
    field: ZOOM_ATTENDANCE_CONSTANTS.FIELDS.HAS_ATTENDED,
    headerName: ZOOM_ATTENDANCE_CONSTANTS.LABELS.ATTENDED,
    valueFormatter: (record) => (record.has_attended ? "Yes" : "No"),
  },
  {
    field: ZOOM_ATTENDANCE_CONSTANTS.FIELDS.TOTAL_MINUTES_ATTENDED,
    headerName: ZOOM_ATTENDANCE_CONSTANTS.LABELS.TOTAL_MINUTES_ATTENDED,
    valueFormatter: (record) =>
      formatMinutesText(record.total_minutes_attended ?? record.duration),
  },
  {
    field: ZOOM_ATTENDANCE_CONSTANTS.FIELDS.TIMES_JOINED,
    headerName: ZOOM_ATTENDANCE_CONSTANTS.LABELS.TIMES_JOINED,
    valueFormatter: (record) =>
      (
        record.times_joined ?? ZOOM_ATTENDANCE_CONSTANTS.NUMERIC.ZERO
      ).toString(),
  },
];

export const sessionParticipantsExporter = _exporterBase({
  responseMapFunction: (item) => {
    const obj = {};
    exporter_config.forEach((col) => {
      const val = col.valueFormatter
        ? col.valueFormatter(item)
        : item[col.field] ?? "";
      obj[col.headerName] =
        val !== undefined && val !== null ? val.toString() : "";
    });
    return obj;
  },
  downloadedCSVFileName: ZOOM_ATTENDANCE_CONSTANTS.LABELS.EXPORT_CSV_FILENAME,
});
